import { _userLevel } from 'ecp/models/UsersModel'

const AdminModel = {
  canSeeTransferColumn: (userLevel: _userLevel) => userLevel === 'master',
  canSeeTransferLog: (userLevel: _userLevel) => userLevel === 'master' || userLevel === 'administrator'

}

export default AdminModel
